<template>
    <div class="logo">
        <img class="img-logo" src="../assets/logo_topcv_white.png" alt="">
    </div>
</template>
<script>
export default {
    name: 'logo'
}
</script>
<style>

.logo{
    padding-top: 2em;
    text-align: center;
}
.img-logo{
    width: 40%
}
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue